export const tagFromName = (x) => ({ id: x.id, text: x.name });
export const tagFromText = (x) => ({ id: x.id, text: x.text });
